module.exports = __webpack_public_path__ + "img/suriname.33aaceef.svg";